export default {
  HTTP_URL: "https://api.mixin.one",
  WS_URL: "wss://mixin-blaze.zeromesh.net"
};